import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabservicepune() {



  const cardData =
  {
    keyword: 'Outstation Cab Service Pune',
    heading: 'Sai Trupti Cabs: Outstation Cab Service Pune',
    headingDescription: 'Sai Trupti Cabs offers dedicated and hassle-free out-station cab services in Pune, designed to make your long-distance journeys smooth, comfortable and worry-free. Whether you’re looking to escape for a weekend getaway, visiting pilgrimage sites, going for corporate travel or simply taking a one-way drop to another city, our fleet of well-maintained, air-conditioned Sedans, SUVs and Premium cars is ready for you. Every ride is driven by a professional, background-verified chauffeur who ensures punctual pickups, courteous service, and safe, smooth driving throughout your journey. With transparent one-way and round-trip pricing, flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your out-station travel from Pune convenient, affordable and dependable.',

    top: 'Top Places to Visit in Pune outstation with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Lonavala and Khandala are twin hill stations nestled in the Sahyadri range, just 65 km from Pune, and are the most popular weekend getaways. Famous for Tiger’s Leap, Bhushi Dam, and Duke’s Nose, these towns offer misty hills, lush valleys, and cascading waterfalls during the monsoon. Adventure seekers enjoy trekking and paragliding, while couples relish the romantic weather. The local chikki and fudge shops add sweetness to every visit. Whether for a short drive or a serene stay, Lonavala and Khandala perfectly capture Maharashtra’s monsoon magic."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Mahabaleshwar and Panchgani, about 120 km from Pune, are twin hill stations known for their strawberry farms, scenic viewpoints, and cool climate. Mahabaleshwar’s Venna Lake, Arthur’s Seat, and Lingmala Waterfall attract nature lovers, while Panchgani’s Table Land offers panoramic views of the valley. The winding ghats, colonial architecture, and aroma of fresh berries create a nostalgic hill-town charm. Visitors also enjoy boating, horse riding, and local delicacies like strawberry cream. Together, they make a refreshing and romantic outstation escape from Pune."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, India’s first planned hill city, lies about 60 km from Pune and blends European elegance with natural tranquility. The colorful Mediterranean-style architecture lines the scenic Lakeside Promenade overlooking Warasgaon Lake. Boating, cycling, and lakeside dining add charm to this peaceful retreat. The cool weather, scenic drive, and luxurious resorts make it ideal for couples and families alike. Lavasa is not just a destination — it’s an experience where nature, design, and relaxation meet in perfect harmony."
  },
  {
    "title": "Bhimashankar",
    "description": "Located around 110 km from Pune, Bhimashankar is both a sacred pilgrimage and a haven for nature lovers. Home to one of Lord Shiva’s twelve Jyotirlingas, the temple sits amidst dense forests and misty mountains. The Bhimashankar Wildlife Sanctuary surrounding the temple shelters the rare Giant Indian Squirrel. Trekking, photography, and forest walks make the visit even more rewarding. The air here carries chants, bird calls, and the fragrance of wet earth — making Bhimashankar a divine escape for both spiritual seekers and adventure enthusiasts."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, about 140 km from Pune, is a coastal paradise known for its clean beaches, forts, and breezy atmosphere. The Kolaba Fort, accessible during low tide, offers panoramic sea views, while Alibaug, Nagaon, and Kashid beaches attract families and couples alike. Water sports like parasailing and banana rides add thrill to the serene environment. With its heritage bungalows, homestays, and seafood restaurants, Alibaug offers the perfect mix of relaxation and coastal charm — an ideal outstation retreat from Pune’s urban buzz."
  },
  {
    "title": "Matheran",
    "description": "Matheran, the only automobile-free hill station in Asia, sits around 120 km from Pune and offers peace like no other. Visitors reach the hilltop via toy train or horseback, surrounded by dense forests and cool winds. The 38 viewpoints, including Echo Point and Panorama Point, provide stunning views of valleys and sunsets. Red mud paths, colonial cottages, and vintage charm make Matheran feel frozen in time. It’s the perfect getaway for nature walks, photography, and quiet introspection away from city noise."
  },
  {
    "title": "Imagicaa Theme Park, Khopoli",
    "description": "Located halfway between Pune and Mumbai, Imagicaa is India’s premier theme park offering thrilling rides, water adventures, and entertainment for all ages. From high-speed roller coasters to family attractions and live shows, it guarantees non-stop excitement. The adjoining AquaMagica water park and Novotel resort make it a complete weekend package. Perfect for families, friends, and corporate groups, Imagicaa transforms a regular trip into an unforgettable adventure filled with laughter, thrill, and color."
  },
  {
    "title": "Nashik",
    "description": "Nashik, about 210 km from Pune, is a blend of spirituality and sophistication — home to the sacred Trimbakeshwar Jyotirlinga and India’s finest vineyards. The Sula Vineyards offer wine tours, tastings, and sunset dining overlooking the grape fields. Ramkund and Panchvati attract devotees, while adventure seekers explore the Anjaneri and Pandavleni caves. The city’s balance of devotion, heritage, and luxury makes it a versatile outstation destination for pilgrims, couples, and weekend travelers alike."
  },
  {
    "title": "Kolad",
    "description": "Kolad, located on the banks of the Kundalika River about 120 km from Pune, is Maharashtra’s adventure capital. It’s best known for white-water rafting, ziplining, and riverside camping. Surrounded by dense greenery and rolling hills, the experience of rafting through the fast-flowing river currents is both thrilling and refreshing. The peaceful nights under the stars by the riverside make Kolad ideal for corporate outings and friend groups. It’s the perfect combination of adrenaline and nature’s serenity."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, about 190 km from Pune, is one of India’s most visited pilgrimage destinations, dedicated to the revered saint Sai Baba. The Samadhi Mandir, Dwarkamai Mosque, and Chavadi attract millions of devotees annually. The town exudes a divine atmosphere filled with chants, incense, and unwavering faith. Visitors also explore nearby attractions like Shani Shingnapur and Sai Heritage Village. Shirdi offers not just spiritual solace but also organized facilities, clean surroundings, and peaceful hospitality — making it an ideal outstation destination for families and devotees alike."
  }
]
,



"services": [
  {
    "name": "Outstation Cab Service Pune",
    "description": "Reliable outstation cab service from Pune for long-distance travel with well-maintained AC and non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares. Ideal for family trips, corporate travel, and weekend getaways, ensuring safe and comfortable journeys across cities."
  },
  {
    "name": "Pune Outstation Taxi",
    "description": "Book Pune outstation taxis with professional chauffeurs, AC/non-AC options, luggage support, and real-time tracking. Perfect for one-way or round trips to nearby cities, weekend trips, or business travel with flexible schedules and transparent pricing."
  },
  {
    "name": "Pune Outstation Car Hire",
    "description": "Hire cars in Pune for outstation trips with a range of options including sedans, SUVs, Innova, and Ertiga. Services include professional drivers, luggage support, AC/non-AC choices, online booking, and reliable fares for safe and convenient travel."
  },
  {
    "name": "Pune AC Outstation Cab",
    "description": "Comfortable AC outstation cabs from Pune for long-distance travel with professional drivers, luggage assistance, flexible schedules, and online booking. Ideal for family trips, corporate travel, or weekend getaways, ensuring a cool and smooth ride."
  },
  {
    "name": "Pune Non AC Outstation Cab",
    "description": "Affordable non-AC outstation cab service in Pune with reliable vehicles, professional drivers, luggage support, and flexible pickup/drop options. Perfect for budget travelers seeking comfortable long-distance travel."
  },
  {
    "name": "Luxury Outstation Cab Pune",
    "description": "Premium luxury outstation cab service from Pune with top-class vehicles, AC service, professional chauffeurs, luggage assistance, flexible schedules, and timely pickups. Ideal for weddings, corporate trips, or VIP travel."
  },
  {
    "name": "Pune Innova Outstation Cab",
    "description": "Hire Innova for outstation trips from Pune with spacious seating for 6-7 passengers, AC/non-AC options, professional drivers, luggage support, and flexible schedules. Perfect for family trips, group travel, or corporate journeys."
  },
  {
    "name": "Pune Ertiga Outstation Cab",
    "description": "Comfortable Ertiga outstation cabs from Pune with seating for 6-7 passengers, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares. Ideal for family outings and long-distance trips."
  },
  {
    "name": "Affordable Outstation Cab Pune",
    "description": "Budget-friendly outstation cab services in Pune with AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, and transparent pricing. Perfect for economical long-distance travel without compromising comfort."
  },
  {
    "name": "Pune Outstation One Way Cab",
    "description": "One-way outstation cab service from Pune for convenient long-distance travel with professional drivers, AC/non-AC vehicles, luggage support, and transparent fares. Ideal for trips where return travel is not required."
  },
  {
    "name": "Pune Outstation Drop Cab",
    "description": "Drop cab service from Pune to outstation destinations with AC/non-AC options, professional drivers, luggage assistance, and flexible schedules. Ensures safe and comfortable travel to your destination without worrying about return journeys."
  },
  {
    "name": "Corporate Outstation Cab Pune",
    "description": "Corporate outstation cab service in Pune offering AC/non-AC vehicles, professional chauffeurs, luggage assistance, flexible schedules, online booking, and transparent pricing. Perfect for business trips, client visits, and corporate events."
  },
  {
    "name": "Wedding Outstation Cab Pune",
    "description": "Premium wedding outstation cab service from Pune with luxurious vehicles, AC/non-AC options, professional drivers, luggage support, and timely pickups. Ideal for transporting family and guests to wedding venues safely and comfortably."
  },
  {
    "name": "Online Outstation Cab Pune",
    "description": "Book your outstation cab from Pune online instantly with secure payments, multiple AC/non-AC options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for planning trips in advance or at short notice."
  },
  {
    "name": "Best Outstation Cab Service Pune",
    "description": "Top-rated outstation cab service from Pune with well-maintained vehicles, AC/non-AC options, professional drivers, luggage assistance, flexible schedules, and transparent fares. Trusted for family trips, corporate travel, and long-distance journeys across cities."
  }
],
"tableData": [
  ["Outstation Cab Service Pune", "Pune Outstation Taxi"],
  ["Pune Outstation Car Hire", "Pune AC Outstation Cab"],
  ["Pune Non AC Outstation Cab", "Luxury Outstation Cab Pune"],
  ["Pune Innova Outstation Cab", "Pune Ertiga Outstation Cab"],
  ["Affordable Outstation Cab Pune", "Pune Outstation One Way Cab"],
  ["Pune Outstation Drop Cab", "Corporate Outstation Cab Pune"],
  ["Wedding Outstation Cab Pune", "Online Outstation Cab Pune"],
  ["Best Outstation Cab Service Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Outstation Cab Service Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable outstation cab services from Pune — ideal for long-distance travel, business trips, family outings, and leisure journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way or round-trip fare estimates for Pune outstation cabs, starting at affordable rates depending on vehicle type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, luxury cars, or tempo travellers to suit your group size, luggage, and travel preferences for any outstation route from Pune."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are trained for long-distance travel, ensuring a safe, smooth, and timely journey for all outstation trips."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at any outstation location across India, including hotels, railway stations, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability during long-distance travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune outstation cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]





























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer outstation cab services from Pune?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable outstation cab services from Pune to various destinations across Maharashtra and India.',
  },
  {
    question: 'How can I book an outstation cab from Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your outstation cab from Pune through our website, mobile app, or by contacting our 24×7 customer support team for quick assistance and instant confirmation.',
  },
  {
    question: 'What types of cabs are available for outstation travel from Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your group size, comfort preferences, and budget for long-distance journeys.',
  },
  {
    question: 'Are the drivers experienced for outstation trips from Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance driving, ensuring a safe and comfortable outstation travel experience.',
  },
  {
    question: 'Can I hire a cab for one-way or round-trip outstation travel from Pune?',
    answer: 'Certainly. Sai Trupti Cabs offers both one-way and round-trip outstation cab services from Pune to major destinations like Mumbai, Shirdi, Mahabaleshwar, Lonavala, and more.',
  },
  {
    question: 'Is the outstation cab service from Pune available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 outstation cab services from Pune to ensure flexibility and convenience for your travel plans.',
  },
  {
    question: 'What are the outstation cab fares from Pune?',
    answer: 'Our outstation cab fares from Pune start from approximately ₹10 per km for sedans and ₹14–₹18 per km for SUVs and larger vehicles, depending on the route and vehicle type.',
  },
  {
    question: 'What payment methods are accepted for outstation cab bookings from Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for hassle-free and secure transactions.',
  },
  {
    question: 'What safety and hygiene measures are followed for outstation cabs from Pune?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure a safe and comfortable journey.',
  },
  {
    question: 'Is customer support available during outstation cab trips from Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your outstation cab journey from Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Patil',
    feedback: 'We booked an outstation cab from Pune to Mahabaleshwar with Sai Trupti Cabs. The driver was punctual and the car was very clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'Sai Trupti Cabs provided excellent outstation cab service from Pune to Shirdi. Smooth ride and very professional service throughout the trip.',
    rating: 5,
  },
];






















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];
















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Service Pune",
  "image": "https://saitrupticabs.com/assets/images/outstation-cab-service-pune.jpg",
  "description": "Reliable outstation cab service from Pune. Book AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/outstation-cab-service-pune"
  }
};




  return (
    <div>
      <Helmet>
  <title>Outstation Cab Service Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Reliable outstation cab service from Pune. Book AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Outstation Cab Service Pune, Pune Outstation Taxi, Pune Outstation Car Hire, Pune AC Outstation Cab, Pune Non AC Outstation Cab, Luxury Outstation Cab Pune, Pune Innova Outstation Cab, Pune Ertiga Outstation Cab, Affordable Outstation Cab Pune, Pune Outstation One Way Cab, Pune Outstation Drop Cab, Corporate Outstation Cab Pune, Wedding Outstation Cab Pune, Online Outstation Cab Pune, Best Outstation Cab Service Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newkey/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabservicepune;